import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Blog } from '../components/Blog';
import { Contact } from '../components/Contact';
export function HomePage() {
  return <>
      <Hero data-id="element-157" />
      <Services data-id="element-158" />
      <Blog data-id="element-159" />
      <Contact data-id="element-160" />
    </>;
}